import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoDotsHorizontal24 = t0 => {
  const $ = _c(12);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  let t4;
  if ($[2] !== iconColor) {
    t2 = <path d="M12 12.625C12.3452 12.625 12.625 12.3452 12.625 12C12.625 11.6548 12.3452 11.375 12 11.375C11.6548 11.375 11.375 11.6548 11.375 12C11.375 12.3452 11.6548 12.625 12 12.625Z" stroke={iconColor} strokeWidth={1.111} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M16.583 12.625C16.9282 12.625 17.208 12.3452 17.208 12C17.208 11.6548 16.9282 11.375 16.583 11.375C16.2378 11.375 15.958 11.6548 15.958 12C15.958 12.3452 16.2378 12.625 16.583 12.625Z" stroke={iconColor} strokeWidth={1.111} strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M7.4165 12.625C7.76168 12.625 8.0415 12.3452 8.0415 12C8.0415 11.6548 7.76168 11.375 7.4165 11.375C7.07133 11.375 6.7915 11.6548 6.7915 12C6.7915 12.3452 7.07133 12.625 7.4165 12.625Z" stroke={iconColor} strokeWidth={1.111} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== ariaLabel || $[7] !== className || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}{t4}</svg>;
    $[6] = ariaLabel;
    $[7] = className;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default IcoDotsHorizontal24;